const EVENT_PUBLISH = 'event-publish';

const publishEventTrigger = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const currentQuery = urlParams.get('load-modal');
	if (currentQuery === 'modal-postpublish') {
			const event = new CustomEvent(EVENT_PUBLISH);
			document.dispatchEvent(event);
	}
};

export {EVENT_PUBLISH, publishEventTrigger};